var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1678 1426",
    width: 1678,
    height: 1426,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vtex-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #f71963 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M1662.43 183.26L1034.66 1357.99C986.17 1448.8 855.26 1448.63 806.94 1357.72L669.64 1099.24L560.2 1304.1C553.1 1317.44 542.47 1328.6 529.46 1336.39C516.46 1344.17 501.57 1348.29 486.39 1348.29C471.21 1348.29 456.32 1344.17 443.32 1336.39C430.31 1328.6 419.69 1317.44 412.58 1304.1L9.62 545.67C2.92 533.02 -0.38 518.85 0.04 504.56C0.45 490.26 4.58 476.31 12.01 464.07C19.44 451.82 29.93 441.69 42.45 434.66C54.97 427.63 69.11 423.93 83.49 423.92L310.61 423.92L185.33 188.02C139.89 102.67 202.08 0 299.19 0L1551.65 0C1646.25 0 1706.8 100.17 1662.43 183.26ZM995.36 475.26C995.11 465.98 992.45 456.92 987.65 448.97C982.84 441.01 976.05 434.43 967.92 429.86C959.8 425.29 950.62 422.89 941.29 422.89L401.03 422.89C391.45 422.92 382.05 425.41 373.73 430.11C365.41 434.81 358.45 441.57 353.52 449.73C348.6 457.9 345.88 467.18 345.62 476.7C345.37 486.22 347.59 495.63 352.07 504.05L620.14 1008.56C624.87 1017.43 631.94 1024.85 640.6 1030.03C649.25 1035.2 659.16 1037.93 669.25 1037.93C679.35 1037.93 689.26 1035.2 697.91 1030.03C706.56 1024.85 713.63 1017.43 718.36 1008.56L989.05 501.91C993.43 493.72 995.6 484.54 995.36 475.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtex);
export default __webpack_public_path__ + "static/media/vtex.a958bb2f89ee49991d0f57ab0236074d.svg";
export { ForwardRef as ReactComponent };